.join {
  /* cream section, preserving the design's hero(blue) → makers(white) → join(cream) alternation */
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
  padding: 76px 0;
}

.join__head {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 32px;
  align-items: center;
  margin-bottom: -8px; /* pulled tight since the framed illustration is nudged up (see .join__illu) */
}

.join__badge {
  display: inline-block;
  background: var(--color-complementary-yellow); /* accent */
  color: var(--color-primary-grey-900);
  font-weight: 700;
  font-size: 11px; /* COPY_XS */
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 9999px;
  margin-bottom: 16px;
}

.join__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: clamp(32px, 4.4vw, 54px);
  letter-spacing: -0.02em;
  line-height: 1.02;
  color: var(--color-primary-grey-900);
  margin: 0;
}

.join__illu {
  width: 100%;
  max-width: 344px;
  aspect-ratio: 1512 / 996; /* the photo's exact ratio, so object-fit: cover fills it with no crop, no white */
  margin-inline: auto;
  /* Nudge the frame up into the section's top padding for a livelier composition. A visual
     transform (no reflow, no negative margins) — reset on the stacked mobile layout below. */
  transform: translate(0, -40px);
}

.join__grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.panel {
  min-width: 0;
  background: var(--color-primary-grey-000);
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 18px;
  padding: 34px 38px;
  box-shadow: var(--plume-shadow-card, 6px 6px 0 var(--color-primary-grey-900));
}

.panelLead__intro {
  font-size: 19px;
  font-weight: 600;
  color: var(--color-primary-grey-900);
  margin: 0 0 14px;
}

.panelLead__intro em {
  font-style: normal;
  background: var(--color-complementary-yellow); /* accent */
  color: var(--color-primary-grey-900);
  padding: 0 0.12em;
  border-radius: 2px;
  font-weight: 700;
}

.panelLead__body {
  font-size: 16px; /* COPY_M */
  line-height: 1.5;
  color: var(--color-primary-sand-900); /* text-2 */
  margin: 0;
}

.join__side {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.mini {
  min-width: 0;
  background: var(--color-primary-grey-000);
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 18px;
  padding: 24px 26px;
  box-shadow: var(--plume-shadow-card, 6px 6px 0 var(--color-primary-grey-900));
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mini__key {
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-tertiary); /* text-3 */
  margin: 0 0 8px;
}

.mini__body {
  font-size: 16px; /* COPY_M */
  color: var(--color-primary-grey-900);
  line-height: 1.5;
  margin: 0;
}

.mini__body a {
  font-weight: 700;
  color: var(--color-primary-blue-700); /* PRIMARY_BLUE_700 */
  text-decoration: underline;
  text-underline-offset: 2px;
}

.mini__body a:hover {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

.join__cta {
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 20px;
  box-shadow: 6px 6px 0 var(--color-complementary-yellow); /* accent sticker shadow */
  padding: 54px 40px;
  text-align: center;
}

.join__ctaKey {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 14px;
}

.join__ctaTitle {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: clamp(28px, 3.8vw, 46px);
  line-height: 1.06;
  letter-spacing: -0.02em;
  color: var(--color-primary-grey-000);
  max-width: 18ch;
  margin: 0 auto 28px;
}

@media (max-width: 880px) {
  .join__head,
  .join__grid {
    grid-template-columns: 1fr;
  }

  /* Stacked layout: the illustration sits below the heading — drop the desktop nudge + tight margin. */
  .join__head {
    margin-bottom: 24px;
  }

  .join__illu {
    transform: none;
  }
}
